import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

// core components
import GridContainer from "/components/Grid/GridContainer.js";
import GridItem from "/components/Grid/GridItem.js";

import styles from "./NavPills.module.scss";

export default function NavPills({ 
  active = 0,
  tabs,
  color = "primary",
  horizontal,
  alignCenter 
}) {
  const [activeState, setActive] = React.useState(active);
  
  const handleChange = (event, active) => {
    setActive(active);
  };
  
  const flexContainerClasses = classNames(styles.flexContainer, {
    [styles.horizontalDisplay]: horizontal !== undefined
  });
  
  const tabButtons = (
    <Tabs
      classes={{
        root: styles.root,
        fixed: styles.fixed,
        flexContainer: flexContainerClasses,
        indicator: styles.displayNone
      }}
      value={activeState}
      onChange={handleChange}
      centered={alignCenter}
    >
      {tabs.map((prop, key) => {
        var icon = {};
        if (prop.tabIcon !== undefined) {
          icon["icon"] = <prop.tabIcon className={styles.tabIcon} />;
        }
        const pillsClasses = classNames({
          [styles.pills]: true,
          [styles.horizontalPills]: horizontal !== undefined,
          [styles.pillsWithIcons]: prop.tabIcon !== undefined
        });
        return (
          <Tab
            label={prop.tabButton}
            key={key}
            {...icon}
            classes={{
              root: pillsClasses,
              label: styles.label,
              selected: styles[color]
            }}
          />
        );
      })}
    </Tabs>
  );
  
  const tabContent = (
    <div className={styles.contentWrapper}>
      {tabs.map((prop, key) => {
        if (key !== activeState) {
          return null;
        }
        return (
          <div className={styles.tabContent} key={key}>
            {prop.tabContent}
          </div>
        );
      })}
    </div>
  );
  
  return horizontal !== undefined ? (
    <GridContainer>
      <GridItem {...horizontal.tabsGrid}>{tabButtons}</GridItem>
      <GridItem {...horizontal.contentGrid}>{tabContent}</GridItem>
    </GridContainer>
  ) : (
    <div>
      {tabButtons}
      {tabContent}
    </div>
  );
}

NavPills.propTypes = {
  // index of the default active pill
  active: PropTypes.number,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabButton: PropTypes.string,
      tabIcon: PropTypes.object,
      tabContent: PropTypes.node
    })
  ).isRequired,
  color: PropTypes.oneOf([
    "primary",
    "warning",
    "danger",
    "success",
    "info",
    "rose"
  ]),
  horizontal: PropTypes.shape({
    tabsGrid: PropTypes.object,
    contentGrid: PropTypes.object
  }),
  alignCenter: PropTypes.bool
};